import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { TellentDevFlagsEffects } from './tellent-dev-flags.effects';
import { TellentDevFlagsNamespace, TellentDevFlagsReducer } from './tellent-dev-flags.store';
import { TellentDevFlagConfigToken } from './utils';

@NgModule({
  imports: [
    EffectsModule.forFeature([TellentDevFlagsEffects]),
    StoreModule.forFeature(
      TellentDevFlagsNamespace,
      TellentDevFlagsReducer,
      TellentDevFlagConfigToken,
    ),
  ],
})
export class TellentDevFlagDataModule {}
